import React, { useState } from "react";
// import { Tab, Tabs } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "font-awesome/css/font-awesome.min.css";
import DeviceTimeline from "./DeviceTimeline";
import StatusTab from "./StatusTab";
import TroubleshootComponent from "./TroubleshootComponent";
import { logFirebaseEvent } from "../services/events";
import UserService from "../utils/userService";
import { SHOW_TROUBLESHOOT_TO_ROLES_IDS } from "../constants/troubleshootComponent";
import { Tabs } from "antd";
import InfoComponent from "./InfoComponent";
import { SCHOOL_DATA_CONSTANTS } from "../constants/schoolData";
import RemoteActionsComponent, {
  SHOW_REMOTE_ACTIONS_TO_ROLES_IDS,
} from "./RemoteActionsComponent";

const InfoTabs = ({
  data,
  updateActivitiesDropDown,
  activites,
  overAllStatus,
  nasPercent,
  isResourceDownloadingMultipleTimes,
  windowWidth,
  nasStatus,
  pagination,
  onChangePagination,
  timelineLoading,
}) => {
  const [selectedDevice, setSelectedDevice] = useState(null);
  const [showModal, setShowModal] = useState("");

  const userInfo = UserService.getUserData();

  function getCardStatusClass() {
    if (overAllStatus > 4) {
      return "bg-card-danger";
    } else if (overAllStatus > 1) {
      return "bg-card-warning";
    }
    return "bg-card-okay";
  }

  const logTabEvent = (tabType) => {
    const cardStatusClass = getCardStatusClass(data);

    let cardStatus = "";
    if (cardStatusClass === "bg-card-danger") {
      cardStatus = "Red";
    } else if (cardStatusClass === "bg-card-warning") {
      cardStatus = "Amber";
    } else {
      cardStatus = "Green";
    }

    logFirebaseEvent(`${tabType}_clicked`, {
      card_login_id: data.teacherMobile,
      card_status: cardStatus,
      last_updated: data.timestamp,
    });
  };

  const handleDeviceClick = (device, event, modalType) => {
    event.stopPropagation();

    setSelectedDevice(device);
    setShowModal(modalType);
  };

  const items = [
    {
      key: "1",
      label: "Status",
      children: (activites?.length || activites?.data?.length) ? (
        <StatusTab
          data={data}
          overAllStatus={data.overallstatus}
          handleDeviceClick={handleDeviceClick}
        />
      ) : (
        <InfoComponent message={SCHOOL_DATA_CONSTANTS.messages.loading} />
      ),
    },
    {
      key: "2",
      label: "Timeline",
      children: (
        <DeviceTimeline
          updateActivitiesDropDown={(value) => updateActivitiesDropDown(value)}
          timelineLoading={timelineLoading}
          deviceData={activites}
          pagination={pagination}
          onChangePagination={onChangePagination}
          deviceId={data?.mdmDeviceId}
        />
      )
    },
  ];

  if (SHOW_TROUBLESHOOT_TO_ROLES_IDS.includes(userInfo.roleid)) {
    items.push({
      key: "3",
      label: "Troubleshoot",
      children: (
        <TroubleshootComponent
          userData={data}
          nasPercent={nasPercent}
          isResourceDownloadingMultipleTimes={
            isResourceDownloadingMultipleTimes
          }
          windowWidth={windowWidth}
          nasStatus={nasStatus}
        />
      ),
    });
  }

  if (SHOW_REMOTE_ACTIONS_TO_ROLES_IDS.includes(userInfo.roleid)) {
    items.push({
      key: "4",
      label: "Remote Actions",
      children: <RemoteActionsComponent data={data} />,
    });
  }
  return (
    <>
      <Tabs
        defaultActiveKey="1"
        items={items}
        className="tab-container"
        onSelect={(tabType) => logTabEvent(tabType)}
      ></Tabs>
    </>
  );
};

export default InfoTabs;